import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useLocation } from "react-router-dom";

export default function Pagination({
  pageCount,
  pageValue,
  setPage,
  setUpdateNotification,
  setLimit,
  limit,
}) {
  const location = useLocation();
  const [inputPage, setInputPage] = useState(pageValue + 1);

  useEffect(() => {
    setInputPage(pageValue + 1);
  }, [pageValue]);

  function newFunction(data) {
    setPage(data);
    if (typeof setUpdateNotification === "function") {
      setUpdateNotification(true);
    }
  }

  const handleInputChange = (event) => {
    setInputPage(event.target.value);
  };

  const handleInputSubmit = (event) => {
    event.preventDefault();
    const page = Number(inputPage) - 1;
    if (page >= 0 && page < pageCount) {
      newFunction(page);
    } else {
      setInputPage(pageValue + 1);
    }
  };

  if (pageCount <= 1) return null;

  return (
    <div className="mc-pagination">
      <ReactPaginate
        pageCount={pageCount}
        forcePage={pageValue}
        previousLabel={"‹"}
        nextLabel={"›"}
        breakLabel={"…"}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        containerClassName={"pagination mc-pagination__pages mb-0"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
        disabledClassName={"disabled"}
        onPageChange={(selected) => {
          newFunction(selected.selected);
        }}
      />

      <form onSubmit={handleInputSubmit} className="mc-pagination__goto">
        {location.pathname === "/re-upload-profile" && (
          <select
            value={limit}
            onChange={(event) => setLimit(event.target.value)}
            className="form-select mc-pagination__limit"
            aria-label="Rows per page"
          >
            <option value={10}>10 / page</option>
            <option value={50}>50 / page</option>
            <option value={100}>100 / page</option>
            <option value={500}>500 / page</option>
          </select>
        )}
        <label className="mc-pagination__goto-label" htmlFor="mc-goto-page">
          Go to
        </label>
        <input
          id="mc-goto-page"
          type="number"
          value={inputPage}
          onChange={handleInputChange}
          min={1}
          max={pageCount}
          className="form-control mc-pagination__goto-input"
          aria-label="Page number"
        />
        <button type="submit" className="btn btn-primary mc-pagination__goto-btn">
          Go
        </button>
      </form>
    </div>
  );
}
